import React, { useState, useEffect } from 'react';
//import './HeaderSort.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { Popover } from 'react-tiny-popover';

interface Props {
	[index: string]: any;
}

const openFilter = React.forwardRef((props: Props, ref: any) => {
	const {
		filterKey,
		filter,
		filters,
		setFilters
	} = props;

	const value = filters?.[filterKey] ?? '';
	const setValue = value => {

		setFilters({
			...filters,
			[filterKey]: value
		})
	};

	let render = null;
	if (filter.render) render = filter.render;
	if (filter.component) {
		const Component = filter.component;
		render = (value, setValue) => <Component ref={ref} value={value} setValue={setValue} />;
	}

	return (
		<div className='header__filter-content' onClick={e => e.stopPropagation()}>
			{render(value, setValue)}
		</div>
	);
});

export default openFilter;
